export default __webpack_public_path__ + "static/media/quotes-01.e17a5a84.png";